<!--
 * @Author: WannTonn
 * @Date: 2021-05-16 10:20:24
 * @LastEditTime: 2021-05-20 17:22:07
 * @LastEditors: WannTonn
 * @Description: 
 * @FilePath: /Fast-front/src/views/system/advisory/qaFeedBack.vue
-->
<template>
  <div class="common-limit line-height-40">
    <el-card>
      <div slot="header">
        反馈问题
      </div>
      <div>
        <el-form ref="form" :model="form" label-width="150px">
          <el-form-item label="功能模板/页面：">
            <el-input
              size="small"
              v-model="form.title"
              placeholder=""
            ></el-input
          ></el-form-item>
          <el-form-item label="问题与建议描述：" required>
            <el-input
              v-model="form.question_desc"
              type="textarea"
              placeholder=""
            ></el-input>
          </el-form-item>
          <el-form-item label="上传附件">
            <el-upload
              action="https://jsonplaceholder.typicode.com/posts/"
              :file-list="fileList"
              list-type="picture"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                最多只能选择5个文件，文件大小小于20M。如果无法选择某个特定文件，请将其压缩成zip文件，并尝试重新添加。
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {},
      fileList: [
        {
          name: "food.jpeg",
          url:
            "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
        {
          name: "food2.jpeg",
          url:
            "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped></style>
